// extracted by mini-css-extract-plugin
export default {"button":"Button_button__cEMu7","loadingIcon":"Button_loadingIcon__GP5lC"};